"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var theme_1 = require("../../utils/theme");
var Badge = (function (_super) {
    tslib_1.__extends(Badge, _super);
    function Badge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a;
            var _b = _this.props, count = _b.count, prefixCls = _b.prefixCls, style = _b.style, status = _b.status, showZero = _b.showZero, text = _b.text, dot = _b.dot, children = _b.children, className = _b.className, overflowCount = _b.overflowCount, offsetX = _b.offsetX, offsetY = _b.offsetY;
            var content = count;
            if (Number(count) > overflowCount) {
                content = overflowCount + "+";
            }
            else if (!count && showZero) {
                content = '0';
            }
            var statusCls = classNames(prefixCls + "-status", (_a = {},
                _a[prefixCls + "-status-" + (status || 'default')] = status,
                _a));
            var offset = { marginRight: -offsetX + "px", marginTop: offsetY + "px" };
            if (status) {
                var cls_1 = classNames(prefixCls, className, prefixCls + "-standalone");
                var textCls = classNames(prefixCls + "-status-text");
                return (h("span", { className: cls_1, style: style },
                    h("span", { className: statusCls }),
                    text && h("span", { className: textCls }, text)));
            }
            if (!children) {
                var cls_2 = classNames(prefixCls, className, prefixCls + "-standalone", prefixCls + "-count", prefixCls + "-count-standalone");
                return content && (h("span", { className: cls_2, style: style }, content));
            }
            var cls = classNames(prefixCls, className);
            if (dot) {
                var dotCls = classNames(prefixCls + "-dot");
                return (h("span", { className: cls },
                    children,
                    h("sup", { className: dotCls, style: tslib_1.__assign(tslib_1.__assign({}, style), offset) })));
            }
            var countCls = classNames(prefixCls + "-count", prefixCls + "-count-attach");
            return (h("span", { className: cls },
                children,
                content ?
                    h("sup", { className: countCls, style: tslib_1.__assign(tslib_1.__assign({}, style), offset) }, content)
                    : null));
        };
        return _this;
    }
    Badge.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return Badge;
}(React.Component));
exports.default = Badge;
Badge.defaultProps = {
    prefixCls: 'dui-badge',
    showZero: false,
    text: '',
    dot: false,
    overflowCount: 99,
    offsetX: 0,
    offsetY: 0
};
